var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltRight } from "@fortawesome/pro-solid-svg-icons/faLongArrowAltRight";
export var Arrow = function (_a) {
    var disabled = _a.disabled;
    return (_jsx("li", __assign({ className: "mt-2" }, { children: _jsx("p", __assign({ className: "text-2xl " + (disabled ? "text-contentAreaBorder" : "text-secondary") }, { children: _jsx(FontAwesomeIcon, { icon: faLongArrowAltRight }, void 0) }), void 0) }), void 0));
};
